import { Button, Tooltip } from "@radix-ui/themes";

import { MessageAdd02 } from "@/v2/assets/icons/MessageAdd02";
import { MailReplyAll } from "@/v2/assets/icons/MailReplyAll";
import { useChat } from "@/v2/features/simulator/context/ChatWrapper";

export function TrainMessage({ onTrain }: { onTrain: () => void }) {
  const { isChatLoading } = useChat();

  return (
    <Tooltip
      content={
        isChatLoading ? "Waiting for messages to load..." : "Start a Session"
      }
    >
      <Button
        size={"1"}
        color={"gray"}
        variant={"outline"}
        highContrast
        style={{
          boxShadow: "var(--shadow-3)",
        }}
        onClick={onTrain}
        disabled={isChatLoading}
      >
        <MessageAdd02 />
      </Button>
    </Tooltip>
  );
}

export function TrainMessageUpTo({ onTrain }: { onTrain: () => void }) {
  const { isChatLoading } = useChat();

  return (
    <Tooltip
      content={
        isChatLoading
          ? "Waiting for messages to load..."
          : "Start a Session with messages up to this one"
      }
    >
      <Button
        size={"1"}
        color={"gray"}
        variant={"outline"}
        highContrast
        style={{
          boxShadow: "var(--shadow-3)",
        }}
        onClick={onTrain}
      >
        <MailReplyAll />
      </Button>
    </Tooltip>
  );
}
